import { render, staticRenderFns } from "./SalaryAdvanceSVG.vue?vue&type=template&id=127cb69e"
import script from "./SalaryAdvanceSVG.vue?vue&type=script&lang=js"
export * from "./SalaryAdvanceSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports